module.exports = "...... loging out"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.html
// module id = ./src/app/logout/logout.component.html
// module chunks = main